module.exports = __webpack_public_path__ + "static/media/river-meditator-600.bee2238b.jpg";